import React, { useRef, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import Header from '../Layout/Header'
import DiaryList from './DiaryList'
import DiaryWrite from './DiaryWrite'
import DiaryDetail from './DiaryDetail'
import DiaryResult from './DiaryResult'
import styles from './DiaryPage.module.css'
import diaryIcon from '../../assets/icons/diary.svg'

const DiaryPage = () => {
  const navigate = useNavigate()
  const { diaryId } = useParams()
  const location = useLocation()
  const diaryListRef = useRef(null)

  useEffect(() => {
    if (location.state?.showWriteDiaryModal && diaryListRef.current) {
      const selectedDate = location.state?.selectedDate ? new Date(location.state.selectedDate) : new Date()
      selectedDate.setHours(0, 0, 0, 0)
      
      if (diaryListRef.current.handleWriteTodayButtonClickWithDate) {
        diaryListRef.current.handleWriteTodayButtonClickWithDate(selectedDate)
      } else if (diaryListRef.current.handleWriteTodayButtonClick) {
        diaryListRef.current.handleWriteTodayButtonClick()
      }
      // state를 초기화하여 뒤로가기 시 모달이 다시 열리지 않도록
      window.history.replaceState({}, '', location.pathname)
    }
  }, [location.state])

  const handleWriteTodayClick = () => {
    if (diaryListRef.current?.handleWriteTodayButtonClick) {
      diaryListRef.current.handleWriteTodayButtonClick()
    }
  }

  const handleNavigateToDashboard = () => {
    navigate('/dashboard')
  }

  const handleNavigateToDiaryList = () => {
    navigate('/diary')
  }

  const handleNavigateToDiaryWrite = (selectedEmotion = null, selectedDate = null) => {
    if (selectedEmotion) {
      navigate('/diary/write', { state: { selectedEmotion, selectedDate } })
    } else {
      navigate('/diary/write')
    }
  }

  const handleNavigateToDiaryDetail = (id) => {
    navigate(`/diary/detail/${id}`)
  }

  const handleNavigateToDiaryResult = (diaryData) => {
    navigate('/diary/result', { state: { diaryData } })
  }

  // URL 경로에 따라 뷰 결정
  if (location.pathname.includes('/diary/write')) {
    return (
      <>
        <DiaryWrite
          onNavigateToDiary={handleNavigateToDiaryList}
          onNavigateToDiaryResult={handleNavigateToDiaryResult}
        />
      </>
    )
  }

  if (location.pathname.includes('/diary/detail/') && diaryId) {
    return (
      <>
        <DiaryDetail
          diaryId={diaryId}
          onNavigateToDiary={handleNavigateToDiaryList}
        />
      </>
    )
  }

  if (location.pathname.includes('/diary/result')) {
    const diaryData = location.state?.diaryData
    return (
      <>
        <DiaryResult
          diaryData={diaryData}
          onNavigateToDiary={handleNavigateToDiaryList}
        />
      </>
    )
  }

  // 기본: 리스트 뷰
  return (
    <>
      <Header />
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          <div className={styles.pageHeader}>
            <img src={diaryIcon} alt="diary" className={styles.diaryIcon} />
            <h1>일기장</h1>
          </div>
          <div className={styles.writeButtonContainer}>
            <button 
              className={styles.writeTodayButton}
              onClick={handleWriteTodayClick}
            >
              <i className="fas fa-plus"></i>
              오늘 일기쓰기
            </button>
          </div>
          <DiaryList
            ref={diaryListRef}
            onNavigateToDashboard={handleNavigateToDashboard}
            onNavigateToDiaryWrite={handleNavigateToDiaryWrite}
            onNavigateToDiaryDetail={handleNavigateToDiaryDetail}
          />
        </div>
      </div>
    </>
  )
}

export default DiaryPage

